import { damageCostsSection } from "./sections/damage_costs.js";
import { paymentSection } from "./sections/payment.js";
import { CLAIM_CURRENCY_INPUT_WIDTH } from "./formDefConstants.js";
import { regulierungSection } from "./sections/regulierung.js";

export const fdefFormC = {
  formdefinition: [
    {
      control: "stepper",
      name: "schadensmeldung",
      label: "Schadenanzeige - Feuer (Gebäude/Inhalt)",
      showSubformErrorCount: false,
      cols: "12",
      steps: [
        {
          label: "Vertragsdaten",
          description: "Der Schaden wird für folgenden Vertrag gemeldet.",
          children: [
            {
              control: "input",
              name: "vertragsnummer",
              label: "Vertragsnummer",
              disabled: "true",
              cols: "6",
            },
            {
              control: "input",
              name: "gesellschaft",
              label: "Gesellschaft",
              disabled: "true",
              cols: "6",
            },
          ],
        },
        {
          label: "Schaden",
          description:
            "Die Frage, 'Was ist passiert?', ist entscheidend, um den Versicherungsschaden korrekt zu bearbeiten. Bitte beschreiben Sie den Vorfall so ausführlich wie möglich. Wo und wann ist er passiert? Welche Umstände haben dazu geführt? Welche Schäden sind aufgetreten? Ihre genaue Beschreibung hilft dem Versicherer, den Schadensfall effizient zu prüfen und die Ansprüche Ihres Mandante zu bearbeiten. Je mehr Informationen Sie bereitstellen, desto besser kann der Versicherer Ihren Schaden prüfen.",
          children: [
            {
              control: "input",
              name: "schaden_nummer_kd",
              label: "eigene Vorgangsnummer",
              cols: "12",
            },
            {
              control: "datepicker",
              name: "schaden_datum",
              label: "Schadensdatum",
              valid:
                "isNotEmpty(item) && !isBigger(item, new Date(), 'Das Schadensdatum darf nicht in der Zukunft liegen.')",
              cols: "6",
            },
            {
              control: "timepicker",
              name: "schaden_uhrzeit",
              label: "Uhrzeit",
              cols: "6",
            },
            {
              control: "switch",
              name: "grossschaden",
              label: "Großschaden",
              cols: 12,
            },
            {
              control: "textarea",
              name: "schaden_ort",
              label: "Schadenort",
              disabled: "true",
              cols: "12",
            },
            {
              control: "textarea",
              name: "schaden_adresszusatz",
              label: "Adresszusatz",
              cols: "12",
            },
            {
              control: "input",
              name: "schaden_besichtigung_adresse",
              label: "Besichtigung (Adresse)",
              cols: "12",
            },
            {
              control: "textarea",
              name: "schaden_betroffene_sachen",
              label: "Betroffene Sachen (Auflistung)?",
              cols: "12",
            },
            {
              control: "textarea",
              name: "schaden_schilderung",
              label: "Schilderung des Hergangs",
              cols: "12",
              valid: "isNotEmpty(item)",
            },
            {
              control: "autocomplete",
              name: "schaden_ursache", //person.cnation
              label: "Ursache des Schadens",
              cols: "12",
              valid: "isNotEmpty(item)",
              get_api: {
                target: "options",
                method: "get",
                endpoint: "data/schaden_ursachen_select",
              },
            },
            {
              control: "sbwarning",
              betrag: [
                "schaden_rechnungsbetrag",
                "schaden_kostenvoranschlag",
                "schaden_hoehe",
              ],
            },
            {
              control: "numberinput", //immer 0
              unit_type: "currency",
              unit: "€",
              allow_negative: false,
              name: "schaden_hoehe",
              label: "Schadenhöhe (eigene Schätzung)",
              input_width: CLAIM_CURRENCY_INPUT_WIDTH,
              cols: {
                xxl: 4,
              },
              valid: "getValue('grossschaden') === false || isNotEmpty(item)",
            },
            {
              control: "numberinput", //immer 0
              unit_type: "currency",
              unit: "€",
              allow_negative: false,
              name: "schaden_kostenvoranschlag",
              label: "Schadenhöhe (Kostenvoranschlag)",
              input_width: CLAIM_CURRENCY_INPUT_WIDTH,
              cols: {
                xxl: 4,
              },
            },
            {
              control: "numberinput", //immer 0
              unit_type: "currency",
              unit: "€",
              allow_negative: false,
              name: "schaden_rechnungsbetrag",
              label: "Schadenhöhe (Rechnung)",
              input_width: CLAIM_CURRENCY_INPUT_WIDTH,
              cols: {
                xxl: 4,
              },
            },
            {
              control: "switch",
              name: "schaden_abtretungserklärung",
              label: "Abtretungserklärung liegt vor ja/nein",
              cols: "12",
            },
            {
              control: "textarea",
              name: "schaden_beschaedigte_sache",
              label: "Was wurde beschädigt?",
              cols: "12",
            },
          ],
        },
        damageCostsSection,
        {
          label: "Polizei",
          description:
            "Falls der Unfall polizeilich aufgenommen wurde, benötigen wir weitere Details.",
          children: [
            {
              control: "switch",
              name: "polizei_aufgenommen",
              label: "polizeiliche Aufnahme ist erfolgt",
              cols: 12,
            },
            {
              control: "input",
              name: "polizei_dienststelle",
              label: "Dienststelle",
              cols: "12",
              hidden: "isNotEqualOther('polizei_aufgenommen', true)",
            },
            {
              control: "input",
              name: "polizei_tagebuchnummer",
              label: "Aktzenzeichen/Tagebuchnummer",
              cols: "12",
              hidden: "isNotEqualOther('polizei_aufgenommen', true)",
            },
            {
              control: "upload",
              name: "polizei",
              label: "polizeiliche Meldung",
              multiple: false,
              add_description: false,
              allowedExtensions: [
                "GIF",
                "TIF",
                "TIFF",
                "JPG",
                "JPEG",
                "PNG",
                "PDF",
                "DOC",
                "DOCX",
                "XLS",
                "XLSX",
                "MSG",
                "EML",
              ],
              cols: "12",
              hidden:
                "isEqualOther('polizei_aufgenommen', false) || isEqualOther('polizei_alkohol_drogen', false)",
            },
          ],
        },

        paymentSection,

        {
          label: "Ansprechpartner",
          description: "",
          children: [
            {
              control: "input",
              name: "ansprechpartner_vorname",
              label: "Vorname",
              cols: "6",
            },
            {
              control: "input",
              name: "ansprechpartner_name",
              label: "Nachname",
              cols: "6",
              valid: "isNotEmpty(item)",
            },
            {
              control: "input",
              name: "ansprechpartner_telefon",
              label: "Telefon",
              cols: "6",
              valid: "isNotEmpty(item)",
            },
            {
              control: "input",
              name: "ansprechpartner_mobil",
              label: "Mobilnummer (wird bevorzugt)",
              cols: "6",
            },
            {
              control: "input",
              name: "ansprechpartner_email",
              label: "E-Mail",
              valid: "isNotEmpty(item) && isEmail(item)",
              cols: "6",
            },
          ],
        },

        {
          label: "Anhänge",
          description: "",
          children: [
            {
              control: "upload",
              name: "sonstiges_unterlagen",
              label:
                "z.B. Farbfotos inkl. Kennzeichen, Kostenvoranschlag, Reparaturrechnung; maximale Größe von 15MB. Ohne Rechnungen und Schadenfotos kann der Schaden nicht zur Prüfung gemeldet werden",
              multiple: true,
              add_description: true,
              allowedExtensions: [
                "GIF",
                "TIF",
                "TIFF",
                "JPG",
                "JPEG",
                "PNG",
                "PDF",
                "DOC",
                "DOCX",
                "XLS",
                "XLSX",
                "MSG",
                "EML",
              ],
              cols: "12",
              valid: "isNotEmpty(item)",
            },
            {
              control: "info",
              title: "Welche Unterlagen haben Sie hochgeladen?",
              description: "Diese Liste dient zur Überprüfung",
            },
            {
              label: "Schadenfotos",
              description:
                "Bitte übermitteln Sie uns Fotos des Schadens. Diese helfen uns, den Schaden schneller und besser zu prüfen.",
              control: "radiogroup",
              name: "schadenfotos",
              cols: "12",
              valid: "isNotEmpty(item)",
              options: [
                {
                  key: "hochgeladen",
                  label: "hochgeladen",
                },
                {
                  key: "Schaden_bereits_behoben",
                  label: "Schaden bereits behoben",
                },
                {
                  key: "Erstellung_nicht_moeglich",
                  label: "Erstellung nicht möglich",
                },
              ],
            },
            {
              label: "Kostenvoranschlag/Rechnung",
              control: "checkbox",
              name: "kostenvoranschlag",
              valid:
                "isEqual(item, true, 'Kostenvoranschlag oder Rechnung sollte hochgeladen werden')",
              default: false,
            },
            {
              label: "Leckortungsbericht",
              control: "checkbox",
              name: "leckortungsbericht",
            },
            {
              label: "Abtretungserklärung",
              control: "checkbox",
              name: "abtretungserklaerung",
            },
          ],
        },
        regulierungSection,
        {
          label: "Abschluß",
          description: "",
          children: [
            {
              control: "switch",
              name: "alles_korrekt",
              label:
                "Die vorstehenden Angaben habe(n) ich/wir wahrheitsgetreu und nach bestem Wissen und Gewissen gemacht. Der Versicherungsnehmer ist für die Richtigkeit der Angaben verantwortlich, auch wenn eine andere Person ihre Niederschrift vornimmt. Bewusst unwahre oder unvollständige Angaben führen auch dann zum Verlust des Versicherungsschutzes, wenn dem Versicherer dadurch kein Nachteil entsteht. Der Versicherer ist bevollmächtigt, bei Behörden in alle diesen Vorfall betreffenden Akten einzusehen und ggf. Abschriften anzufertigen. Wir sind damit einverstanden, dass die Abwicklung ohne vorherige Information ggf. direkt mit den Geschädigten erfolgen kann.",
              cols: 12,
              valid: "isEqual(item, true, 'Die Bestätigung ist verpflichtend')",
            },
          ],
        },
      ],
    },
  ],
  transformIn: [
    {
      fn: "copyIfEmpty",
      source: "bezeichnung",
      target: "schaden_ort",
    },
    {
      fn: "copyIfEmpty",
      source: "bezeichnung",
      target: "schaden_besichtigung_adresse",
    },
    {
      fn: "copyIfEmpty",
      source: "user.vorname",
      target: "ansprechpartner_vorname",
    },
    {
      fn: "copyIfEmpty",
      source: "user.nachname",
      target: "ansprechpartner_name",
    },
    {
      fn: "copyIfEmpty",
      source: "user.telefon",
      target: "ansprechpartner_telefon",
    },
    {
      fn: "copyIfEmpty",
      source: "user.email",
      target: "ansprechpartner_email",
    },
  ],
  transformOut: [
    {
      fn: "setConst",
      target: "docx_template",
      value: "C_Feuer",
    },
  ],
};
